
import React from "react";

interface ImportResultsProps {
  stats: {
    total: number;
    success: number;
    failed: number;
  } | null;
}

const ImportResults: React.FC<ImportResultsProps> = ({ stats }) => {
  if (!stats) return null;
  
  return (
    <div className="bg-elfGreen-lighter border border-elfGreen rounded-md p-3">
      <h4 className="font-medium">Import Results</h4>
      <ul className="mt-2 space-y-1">
        <li>Total items: {stats.total}</li>
        <li>Successfully imported: {stats.success}</li>
        <li>Failed validation: {stats.failed}</li>
      </ul>
    </div>
  );
};

export default ImportResults;
